import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import PrimaryButton from 'components/button/PrimaryButton';
import InputStyled from 'components/InputStyled';
import {
  IAbility,
  IAbilityLocalization,
  IItem,
  IItemLocalize,
  IModalVisible,
  ISupportLanguage,
} from 'utils/types/storyTypes';
import SelectStyled from 'components/SelectStyled';

/**
 * * 리소스 - 미니컷 등록 모달
 */

interface IProps {
  visibleState: IModalVisible; // 팝업 활성, 비활성 정보
  setVisibleState: React.Dispatch<React.SetStateAction<IModalVisible>>;

  langList: ISupportLanguage[];

  targetData: IItem | IAbility | null; // 로컬라이징 정보를 포함하고있는 대상정보 (item, profile 등등)
  setTargetData: React.Dispatch<React.SetStateAction<any>>; // 타겟 데이터 state 처리용

  textIndex: number; // 텍스트 인덱스
  selectedTextRow: IItemLocalize | IAbilityLocalization;

  firstColumnName: string;
}

const EditModal = ({
  visibleState,
  setVisibleState,

  langList,

  targetData,
  setTargetData,

  selectedTextRow,
  textIndex,

  firstColumnName,
}: IProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>('');
  const [langSelect, setLangSelect] = useState<any>(null);

  useEffect(() => {
    if (selectedTextRow) {
      console.log(`Ability Edit modal : `, selectedTextRow);

      // setInputValue(selectedTextRow?.item_name);
      setLangSelect(selectedTextRow?.lang);

      if ('item_name' in selectedTextRow) {
        setInputValue(selectedTextRow?.item_name);
      } else if ('ability_name' in selectedTextRow) {
        setInputValue(selectedTextRow?.ability_name);
      }
    }
  }, [selectedTextRow]);

  const handleSubmit = async () => {
    const cloneData = structuredClone(targetData);

    if (!cloneData) return;

    if ('localizations' in cloneData) {
      cloneData.localizations.forEach((l) => {
        if (l.lang == selectedTextRow.lang) {
          if ('item_name' in l) {
            l.item_name = inputValue;
          } else if ('ability_name' in l) {
            l.ability_name = inputValue;
          }

          l.updated = true;
        }
      });
    }

    // cloneData['localizations'][selected.i].lang = langSelect;
    // cloneData['localizations'][selected.i].item_name = inputValue;

    setTargetData(cloneData);

    handleClose();
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisibleState({ ...visibleState, edit: false });
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleLanguageChange = (e: string) => {
    setLangSelect(e);
  };

  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.operationContent.editPage.modal.edit.title',
      )}
      open={visibleState.edit}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.save')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <div>
          <p className='title'>편집</p>
          <SelectStyled
            disabled={true}
            size='large'
            bordered={false}
            value={langSelect}
            // suffixIcon={
            //   <img src={isOpen ? arrowUp : arrowDown} alt="arrow" />
            // }
            style={{ width: '100%' }}
            onChange={(e) => {
              handleLanguageChange(`${e}`);
            }}
            options={langList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </div>
        <div>
          <p className='title'>{firstColumnName}</p>
          <InputStyled
            value={inputValue}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
            maxLength={30}
          />
          <p className='length-subtext'>
            {typeof inputValue?.length === 'number'
              ? `${inputValue?.length}/30 characters`
              : '0/30 characters'}
          </p>
        </div>
      </SectionWarpper>
    </CustomModal>
  );
};

export default EditModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .checkbox-section {
    display: flex;
    align-items: center;
    & > * + * {
      margin-left: 48px;
    }
  }
  .checkbox-item {
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-weight: ${theme.fontWeights.normal};
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #000000;
    }
    & > * + * {
      margin-left: 8px;
    }
  }
`;
